export interface IAllBanners {
  Banners: IBanners[];
}

export enum ESectionLocation {
  TOP = 'TOP',
  UNDER_DASHBOARD = 'UNDER_DASHBOARD',
  INDO_DASHBOARD = 'INDO_DASHBOARD',
  END_DASHBOARD = 'END_DASHBOARD',
  SIDE_LEFT_1 = 'SIDE_LEFT_1',
  SIDE_LEFT_2 = 'SIDE_LEFT_2',
  SIDE_LEFT_3 = 'SIDE_LEFT_3',
  SIDE_RIGHT = 'SIDE_RIGHT',
}

export enum EBannerSize {
  VERTICAL_BANNER = '300x250',
  SKY_SCRAPPER = '300x600',
  MEDIUM_RECTANGLE = '300x250',
  MOBILE_LEADERBOARD = '450x50',
  CUSTOME = 'autox90',
}

export interface IBanners {
  Clicks: number;
  Description: string;
  EndTime: string;
  Height: number;
  Id: string;
  ImageUrl: string;
  GoogleAdSenseScript: string;
  Impressions: number;
  IsActive: boolean;
  IsMain: boolean;
  IsTorito: boolean;
  IsGoogleAdSense: boolean;
  MaxImpressions: number;
  Priority: number;
  SectionLocation: ESectionLocation;
  StartTime: string;
  Url: string;
  Width: number;
}
